import { Fragment, useState } from 'react';

import { RegisterInvoiceService as Service } from '../../../service/invoice/RegisterInvoiceService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { View } from './View';

export const List = () => {

  const header = 'Mẫu hóa đơn';
  const dataKey = 'id';

  const [displayPreview, setDisplayPreview] = useState(false);
  const [htmlPreview, setHtmlPreview] = useState(null);

  const { render: renderDataTable, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'invoiceTypeName', header: 'Loại hoá đơn', minWidth: 160, matchMode: 'contains' },
      { field: 'symbolCode', header: 'Ký hiệu', width: 160, matchMode: 'contains' },
      { field: 'numberRecord', header: 'Số dòng in mẫu', width: 180, matchMode: 'equals', filterType: 'number', dataType: 'number' },
      { field: 'creatorName', header: 'Người lập', width: 160, matchMode: 'contains' },
      { field: 'creationTime', header: 'Ngày lập', width: 160, matchMode: 'equals', filterType: 'date', dataType: 'date' },
      { field: 'use', header: 'Sử dụng', width: 100, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean' }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { renderToolbar } = useToolbar({
    dataKey,
    create: () => {
      window.location.hash = '/phat-hanh/mau-hoa-don/create';
    },
    update: (item: any) => {
      window.location.hash = '/phat-hanh/mau-hoa-don/update/' + item[dataKey];
    },
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      {
        label: 'Xem mẫu hóa đơn', icon: 'pi pi-fw pi-eye', className: 'iam-toolbar iam-toolbar-help', command: () => {
          if (selectedItems && selectedItems[dataKey]) {
            Service.get(selectedItems[dataKey]).then(data => {
              if (data && data.fileContent) {
                setHtmlPreview(data.fileContent);
                setDisplayPreview(true);
              }
            });
          }
        }
      },
      {
        label: 'Copy mẫu hóa đơn', icon: 'pi pi-fw pi-copy', className: 'iam-toolbar iam-toolbar-help', command: () => {
          if (selectedItems && selectedItems[dataKey]) {
            window.location.hash = '/phat-hanh/mau-hoa-don/update/' + selectedItems[dataKey] + '?copy=Y';
          }
        }
      }
    ]
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      <View display={displayPreview} setDisplay={setDisplayPreview} html={htmlPreview} />
    </Fragment>
  )
}
